// extracted by mini-css-extract-plugin
export default {"substituteImage":"SpForm_substituteImage__QduTf"};